var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Card",
    { staticClass: "trade-order" },
    [
      _c("template", { slot: "header" }, [
        _c("div", { staticClass: "header flex align-center" }, [
          _c("a", { staticClass: "pointer title mar-r5" }, [
            _c("span", [_vm._v("企业交易看板")])
          ]),
          !_vm.purchaseAuthority
            ? _c(
                "div",
                { staticClass: "pointer flex items-center" },
                [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        placement: "bottom",
                        effect: "dark",
                        content:
                          "抱歉，您没有查看权限。若需要查看请联系公司管理员分配权限"
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-warning-outline gray6 f18 mar5-l"
                      })
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ])
      ]),
      _c("div", { staticClass: "items" }, [
        _c("a", { staticClass: "gray6 item" }, [
          _vm.purchaseAuthority
            ? _c("span", { staticClass: "num" }, [
                _vm._v(_vm._s(_vm.shoppingNum || 0))
              ])
            : _c("span", { staticClass: "num" }, [_vm._v("****")]),
          _c("span", [_vm._v("进货车")])
        ]),
        _c("a", { staticClass: "gray6 item" }, [
          _vm.purchaseAuthority
            ? _c("span", { staticClass: "num" }, [
                _vm._v(_vm._s(_vm.orderInfo.dzfOrderNum || 0))
              ])
            : _c("span", { staticClass: "num" }, [_vm._v("****")]),
          _c("span", [_vm._v("待支付")])
        ]),
        _c("a", { staticClass: "gray6 item" }, [
          _vm.purchaseAuthority
            ? _c("span", { staticClass: "num" }, [
                _vm._v(_vm._s(_vm.orderInfo.refundStatusCount || 0))
              ])
            : _c("span", { staticClass: "num" }, [_vm._v("****")]),
          _c("span", [_vm._v("售后")])
        ]),
        _c("a", { staticClass: "gray6 item" }, [
          _vm.purchaseAuthority
            ? _c("span", { staticClass: "num" }, [
                _vm._v(_vm._s(_vm.orderInfo.orderStatus2 || 0))
              ])
            : _c("span", { staticClass: "num" }, [_vm._v("****")]),
          _c("span", [_vm._v("待发货")])
        ]),
        _c("a", { staticClass: "gray6 item" }, [
          _vm.purchaseAuthority
            ? _c("span", { staticClass: "num" }, [
                _vm._v(_vm._s(_vm.orderInfo.orderStatus3 || 0))
              ])
            : _c("span", { staticClass: "num" }, [_vm._v("****")]),
          _c("span", [_vm._v("待收货")])
        ]),
        _c("a", { staticClass: "gray6 item" }, [
          _vm.purchaseAuthority
            ? _c("span", { staticClass: "num" }, [
                _vm._v(_vm._s(_vm.orderInfo.orderStatus4 || 0))
              ])
            : _c("span", { staticClass: "num" }, [_vm._v("****")]),
          _c("span", [_vm._v("待评价")])
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }